import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import { useLocation, useNavigate } from "react-router-dom";

interface IFooterItem {
  id: number;
  icon: string;
  title: string;
  route: string;
  activeIcon: string;
}

const Footer = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (route: string) => {
    navigate(route);
  };

  const footerItems = [
    {
      id: 0,
      icon: theme.image.home_icon.default,
      activeIcon: theme.image.home_icon_black.default,
      title: "홈",
      route: "/",
    },

    {
      id: 1,
      icon: theme.image.camera_icon.default,
      activeIcon: theme.image.camera_icon_black.default,
      title: "상품등록",
      route: "/capture-list",
    },
    {
      id: 2,
      icon: theme.image.bag_icon.default,
      activeIcon: theme.image.bag_icon_black.default,
      title: "등록내역",
      route: "/register-list",
    },
    {
      id: 3,
      icon: theme.image.person_icon.default,
      activeIcon: theme.image.person_icon_black.default,
      title: "마이페이지",
      route: "/my-page",
    },
  ];

  return (
    <FooterContainer>
      {footerItems.map((item: IFooterItem) => (
        <FooterItem
          key={item.id}
          active={location.pathname === item.route}
          onClick={() => handleClick(item.route)}>
          <Image
            src={location.pathname === item.route ? item.activeIcon : item.icon}
            width="24px"
            height="24px"
            pointer
          />
          {item.title}
        </FooterItem>
      ))}
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  display: "flex",
  alignItem: "center",
  justifyContent: "space-between",
  padding: "0 2rem",
  width: "100%",
  maxWidth: "560px",
  height: "80px",
  backgroundColor: theme.color.white,
  textAlign: "center",
  zIndex: 2,
  borderTop: `1px solid ${theme.color.border_gray}`,
}));

const FooterItem = styled.div<{ active: boolean }>(({ theme, active }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100px",
  height: "100%",
  gap: "0.4rem",
  cursor: "pointer",
  fontSize: "1rem",
  lineHeight: "1.2rem",
  fontWeight: theme.fontWeight.regular,
  color: active ? theme.color.black : theme.color.gray,
}));
